import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { autoSyncDisableError, autoSyncDisableSuccess } from './actions'
import { AUTO_SYNC_DISABLE_ASYNC } from './constants'

const disableAutoSyncEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(AUTO_SYNC_DISABLE_ASYNC.INITIATE).mergeMap(() =>
    api.mailboxes
      .disableAutoSync(store.getState().partnerOptions.selectedCompany?.value)
      .map(() => autoSyncDisableSuccess())
      .catch((error) => Observable.of(epicsErrorHandler(autoSyncDisableError, error)))
      .takeUntil(action$.ofType(AUTO_SYNC_DISABLE_ASYNC.CANCEL))
  )

export default combineEpics(disableAutoSyncEpic)
